import { Component, OnInit, Type } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ListViewItem } from 'app/components/common/listViewItem';
import { ConfigService } from 'app/services/config.service';
import { CustomValidators } from 'app/shared/customValidators';
import { TemperatureUnit, WeatherModel } from 'app/views/presentations/models/weather.model';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export class WeatherWidget extends Widget {
    public type: string = 'Weather';
    public icon: string = 'fa-cloud';
    public nameResourceKey: string = 'modules.editors.weather.name';
    public componentType: Type<WidgetComponent> = WeatherWidgetComponent;
}

@Component({
    selector: 'psm-weather-widget',
    templateUrl: 'weather.widget.html'
})
export class WeatherWidgetComponent extends WidgetComponent<WeatherModel>  {
    public temperatureUnit: TemperatureUnit;
    public weatherDuration: number;
    public cities: Set<string>;

    public form: FormGroup;

    public weatherDurationButtons: ListViewItem[] = [];

    public unitsButtons: ListViewItem[] = [
        { key: 'C', label: 'modules.editors.weather.celcius' },
        { key: 'F', label: 'modules.editors.weather.fahrenheit' }
    ];

    constructor(private translate: TranslateService, private configService: ConfigService) {
        super();
    }

    public async initialize() {
        this.weatherDurationButtons = [
            { key: await this.configService.get('WeatherSpeedFast', 5000), label: 'modules.editors.speed-option.Fast' },
            { key: await this.configService.get('WeatherSpeedNormal', 20000), label: 'modules.editors.speed-option.Normal' },
            { key: await this.configService.get('WeatherSpeedSlow', 40000), label: 'modules.editors.speed-option.Slow' }
        ];

        if (!this.content) {
            this.content = new WeatherModel();
        }

        this.temperatureUnit = this.content.temperatureUnit;
        this.weatherDuration = this.content.weatherDuration;
        this.cities = new Set(this.content.cities);

        this.form = new FormGroup({
            temperatureUnit: new FormControl(
                this.temperatureUnit,
                [CustomValidators.isInArray(this.unitsButtons.map(x => x.key), 'modules.editors.weather.invalid-units-error')]
            ),

            cities: new FormControl(
                this.cities,
                [CustomValidators.requiredWithCustomMessage('modules.editors.weather.no-cities-error')]
            ),

            weatherDuration: new FormControl(
                this.weatherDuration,
                [CustomValidators.isInArray(this.weatherDurationButtons.map(x => x.key), 'modules.editors.weather.invalid-speed-error')]
            )
        });

        this.form.valueChanges.subscribe(() => this.onChange());
    }

    public onChange() {
        this.content = new WeatherModel(this.temperatureUnit, this.weatherDuration, Array.from(this.cities));
    }

    public async getFormControls(): Promise<AbstractControl[]> {
        return [this.form];
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/weather/weather.widget.ts